<template>
  <div>
    <div v-if="loading" class="agreement-loading">正在加载{{ title }}…</div>
    <div v-else-if="error" class="agreement-error">{{ error }}</div>
    <div v-else>
      <div v-if="isPrivacyPolicy" class="agreement-sensitive-banner">
        <p class="agreement-sensitive-title">【特别提示】本应用处理的个人敏感信息</p>
        <p class="agreement-sensitive-desc">
          请您重点阅读：我们仅在实现业务功能所必需的范围内处理下列个人敏感信息，未经您同意不会用于其他目的：
        </p>
        <ul class="agreement-sensitive-list">
          <li v-for="item in sensitiveItems" :key="item.name">
            <strong>{{ item.name }}</strong>：{{ item.purpose }}
          </li>
        </ul>
        <p class="agreement-sensitive-footer">
          您有权拒绝提供上述信息，但可能导致相关功能无法使用。详情见下文各条款。
        </p>
      </div>
      <div class="agreement-content" v-html="displayHtml"></div>
    </div>
  </div>
</template>

<script>
import { fetchAgreementInfo } from "@/lib/agreementApi";
import {
  APP_SENSITIVE_INFO_ITEMS,
  prepareAgreementHtml,
} from "@/lib/privacySensitiveHighlight";

export default {
  name: "AgreementContent",
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isPrivacyPolicy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      html: "",
      loading: true,
      error: "",
      sensitiveItems: APP_SENSITIVE_INFO_ITEMS,
    };
  },
  computed: {
    displayHtml() {
      return prepareAgreementHtml(this.html, this.isPrivacyPolicy);
    },
  },
  watch: {
    type: {
      immediate: true,
      handler() {
        this.loadAgreement();
      },
    },
  },
  methods: {
    async loadAgreement() {
      this.loading = true;
      this.error = "";
      try {
        this.html = await fetchAgreementInfo(this.type);
      } catch (err) {
        this.error = (err && err.message) || "加载失败，请稍后重试";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
